import React, { useContext, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../../common/CommonFuctions';
import PropTypes from 'prop-types';
import CLabel from '../../../../../Common/CLabel';
import CTextAreaSimple from '../../../../../Common/CTextAreaSimple';
import { Col, Form, Row } from 'react-bootstrap';
import moment from 'moment';
import { OverflowSet, Dropdown, SpinnerSize, Pivot, PivotItem, TooltipHost, css, TooltipOverflowMode } from "@fluentui/react";
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import ReactDOM from 'react-dom';
import { enum__GapActionTypes, __ActionStatus, __DocumentTypeKeys, __MessageTypes, enum__PRIVILEGES, __enum_PageMode, enum__ActionStatus } from '../../../../../../common/Dictionaries';
import { base64ToArrayBuffer, getGridLocalization, getKeyByValue, isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, saveByteArray } from '../../../../../../common/Helpers';
import { getDocumentsDownload, getListGapActionDocuments, saveActionsByElementId, saveActionsComment } from '../../../../../../services/sKPI/gap.service';
import { useGetListGapActionDocuments, useGetListGapActionEvents, useGetListGapAnalyzeComments } from '../../../../../../hooks/services/sKPI/useOfGAP';
import { removeDocumentById } from '../../../../../../services/sKPI/document.service';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { showMessage } from '../../../../../../common/Helpers';
import CValidator from '../../../../../Common/CValidator';
import Picker from '../../../../../Common/Picker';
import CDatePicker from '../../../../../Common/CDatePicker';
import CTextBox from '../../../../../Common/CTextBox';
import MainAppContext from '../../../../../../MainAppContext';
import GapAppContext from '../../../../../../GapAppContext';
import { _checkSecurityUser } from '../../../../../../common/Helpers/HLP_Security';
import { useGetPrivilegePartyMembersCustom } from '../../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { addTransversalDocument } from '../../../../../../services/sBook/document.service';
import Loading from '../../../../../Templates/Site/Loading';
import { FILE_MAX_SIZE } from '../../../../../../configurations/application.config';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { useDispatch } from 'react-redux';
import { action_setGapActions } from '../../../../../../reducers/actions/KPI/actions';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import './style.css'
import { cloneDeep } from 'lodash-es';
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from '../../../../../../services/Env/transversal.service';

const DialogAction = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const contextSite = useContext(MainAppContext);
    const contextGap = useContext(GapAppContext);
    //##La entidad deberia ser buscada nuevamente ya que de lo contrario muestra data antigua, esto ya que este componente esta en varios lugares.
    const { 
        inputParam_EditMode = null,
        inputParam_IsDialogOpen = null,
        inputParam_SetterIsDialogOpen = null,
        inputParam_DialogEntity = null,
        inputParam_GapAnalyzeId = null,
        inputParam_SetterCauseActionList = null,
        inputParam_GapElementId = null,
        inputParam_SelectedCauses = [],
    } = props;

    const fileUploadControl = useRef();

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const actionStatusList = [...__ActionStatus].sort((a, b) => a.index - b.index).map(function(item) { return { key: item.key, text:  t(item.text) } });

    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [downloadInProgress, setDownloadInProgress] = useState(false);
    
    const [objAction, setObjAction] = useState(inputParam_DialogEntity);

    const [selectedActionStatusKey, setSelectedActionStatusKey] = useState((objAction.statusId === 0 ? actionStatusList[0].key : objAction.statusId));

    const [objIsValidForm, setObjIsValidForm] = useState({
        isInValidBeginDate      : false,
        isInValidEndDate        : false,
        isInvalidAction         : false,
        isInvalidTitle          : false,
        isInvalidOwner          : false,
        isInvalidExecutor       : false,
        isInvalidStatus         : false,
    })

    const [selectedPivotKey, setSelectedPivotKey] = useState("0");

    const [actionComment, setActionComment] = useState(null);
    const [logPage, setLogPage] = useState(1);
    const [logTake, setLogTake] = useState(10);

    const [showAddForm, setShowAddForm] = useState(false)

    const [actionCommentList, setActionCommentList] = useState(null);
    useGetListGapAnalyzeComments(inputParam_GapAnalyzeId, null, null, objAction.id, null, 'gapaction', actionCommentList, setActionCommentList, inputParam_IsDialogOpen);


    const [actionLogList, setActionLogList] = useState(null);
    useGetListGapActionEvents(inputParam_GapAnalyzeId, objAction.id, actionLogList, setActionLogList, inputParam_IsDialogOpen, logPage, logTake);


    const [isInvalidActionStatus, setIsInvalidActionStatus] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [documentLinkList, setDocumentLinkList] = useState(null);
    useGetListGapActionDocuments(objAction.id, documentLinkList, setDocumentLinkList, inputParam_IsDialogOpen);

    const [elementUserOwnerList, setElementUserOwnerList] = useState(null);
    useGetPrivilegePartyMembersCustom(inputParam_GapElementId, elementUserOwnerList, setElementUserOwnerList, true, [objAction.owner], inputParam_IsDialogOpen, true)

    const [elementUserExecutorList, setElementUserExecutorList] = useState(null);
    useGetPrivilegePartyMembersCustom(inputParam_GapElementId, elementUserExecutorList, setElementUserExecutorList, true, [objAction.executor], inputParam_IsDialogOpen, true)
    
    const _priv_canChangeStatusToAllExceptCompleted = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, (!isNullUndefinedOrEmpty(inputParam_GapElementId) ? parseInt(inputParam_GapElementId) : null), enum__PRIVILEGES.GAP_CONTRACT_EJECUTE)
    const _priv_canChangeStatusToCompleted = _checkSecurityUser(contextGap.userPropsKpi.value.onlyObserver, contextGap.userPropsKpi.value, contextSite.securityProps, (!isNullUndefinedOrEmpty(inputParam_GapElementId) ? parseInt(inputParam_GapElementId) : null), enum__PRIVILEGES.GAP_CONTRACT_APROVE)
    const canEdit = contextSite.securityProps.isSAdmin || contextSite.securityProps.isAdmin ?
    true
    :
    (objAction.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED ?
        (_priv_canChangeStatusToAllExceptCompleted.value && _priv_canChangeStatusToAllExceptCompleted.mode === __enum_PageMode.Edit) ||
        (_priv_canChangeStatusToCompleted.value && _priv_canChangeStatusToCompleted.mode === __enum_PageMode.Edit) : false);

    const onCloseDialog = () => {
        inputParam_SetterIsDialogOpen()
        setElementUserOwnerList(null)
        setElementUserExecutorList(null)
    }

    const onGetPrevCommentsClick = () => {
        setLogPage(logPage - 1)
    }

    const onGetNextCommentsClick = () => {
        setLogPage(logPage + 1)
    }

    const onUploadFile = async () => {
        //const ojbClientFormData = new FormData();
        //ojbClientFormData.append("file", selectedFile);
        //ojbClientFormData.append("id", objAction.id);
        //ojbClientFormData.append("url", 'SkGAP/gapactiondocumentadd');
        if (!isNullUndefined(selectedFile)) {
            if (handleFileInput(selectedFile)) {
                showMessage(setMessageConfig, false, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
                setUploadInProgress(true);
                await envDocumentGetUrl('SkGAP/gapactiondocumentadd', objAction.id, selectedFile.name).then(async (responseGetUrl) => {
                    if (responseGetUrl.data.succeeded === true) {
                        await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                            if (responseAzure.data === "" && responseAzure.status === 201) {
                                await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                    if (responseValidate.data.succeeded === true) {
                                        if (responseValidate.data.data.result_validate === true) {
                                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                                            setDocumentLinkList(null);
                                            setSelectedFile(null);
                                            if (fileUploadControl.current) {
                                                fileUploadControl.current.value = '';
                                            }
                                            setUploadInProgress(false);
                                        }
                                        else {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg))
                                            setDownloadInProgress(false)
                                        }
                                    }
                                    else {
                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.message))
                                        setUploadInProgress(false);
                                    }
                                })
                                .catch((error) => {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                });
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            }
                        })
                        .catch(async (error) => {
                            await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            })
                            .catch((error) => {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            });
                        });
                    } else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseGetUrl.data.message))
                        setUploadInProgress(false);
                    }
                    setSelectedFile(null);
                    setUploadInProgress(false);
                })
                .catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setUploadInProgress(false);
                });
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
            }
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
        }
    }

    const onChangePickerOwner = (currentNode, selectedNodes) => {
        let clear = false;
        setterUserFromListToForm(currentNode, setElementUserOwnerList, 'username', 'username', elementUserOwnerList, clear)

        setObjAction(prevState => ({
            ...prevState,
            owner: currentNode.username
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidOwner: currentNode.username === ""
        }));

        showMessage(setMessageConfig, false, null, null)
    }

    const setterUserFromListToForm = (item, setter, fieldFromList, fieldFromForm, list, clear) => {
        list.forEach(x => {
            x.checked = false;
            if (!clear) {
                if (x[fieldFromList] === item[fieldFromForm]) {
                    x.checked = item.checked !== undefined ? item.checked : true;
                }
            }
        })
        setter(list)
    }

    const onSelectPivotKey = (item, ev) => {
        try {
            const pivotKey = item.key.replace(".", "");

            /*if (pivotKey === '2') {
                setDocumentList(prevState => ({
                    ...prevState,
                    fireUpdate:true
                }))
            }*/

            setSelectedPivotKey(pivotKey)
        } catch (error) {
            
        }
    }

    const setterControlValue = (controlValue, controlName) => {
        setObjAction(prevState => ({
            ...prevState,
            [controlName]: controlValue,
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidTitle: controlValue === ""
        }));
    }

    const setterControlTextAreaValue = (e) => {
        const { value } = e.currentTarget; // <-- moved outside asynchronous context

        setObjAction(prevState => ({
            ...prevState,
            action: value,
        }));

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidAction: value === ""
        }));
    }

    const onChangePickerExecutor = (currentNode, selectedNodes) => {
        setObjAction(prevState => ({
            ...prevState,
            executor: currentNode.username
        }));

        let clear = false;
        setterUserFromListToForm(currentNode, setElementUserExecutorList, 'username', 'username', elementUserExecutorList, clear)

        setObjIsValidForm(prevState => ({
            ...prevState,
            isInvalidExecutor: currentNode.username === ""
        }));
        
        showMessage(setMessageConfig, false, null, null)
    }

    const setterControlDatePickerValue = (value, controlName) => {
        setObjAction(prevState => ({
            ...prevState,
            [controlName]: moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        }));

        if (controlName === "beginDate") {
            setObjIsValidForm(prevState => ({
                ...prevState,
                isInValidBeginDate: value === ""
            }));
        }
        else if (controlName === "beginDate") {
            setObjIsValidForm(prevState => ({
                ...prevState,
                isInValidEndDate: value === ""
            }));
        }
    }

    const onDownloadDocumentsByIds = (documentList, fileName) => {
        setDownloadInProgress(true);
        getDocumentsDownload(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
            setDownloadInProgress(false);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setDownloadInProgress(false);
        });
    }

    const onCancelUpload = () => {
        setSelectedFile(null);
        fileUploadControl.current.value = "";
        showMessage(setMessageConfig, false, __MessageTypes.WARNING, '')
    }

    const handleFileInput = (e) => {
        // handle validations
        const file = !isNullUndefined(e.target) ? e.target.files[0] : e;
        let flag = false;
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                setSelectedFile(file);
            }
            else {
                flag = true;
                setSelectedFile(file);
            }
        }
        return flag;
    }

    const commandItems = [
        {
            key: 'uploadDocument',
            text: t('data-lang-btn-upload'),
            iconProps: { iconName: 'Upload' },
            onClick: () => onUploadFile(),
            disabled: selectedFile === null
        },
        {
            key: 'cancelUpload',
            text: t('data-lang-btn-cancel'),
            iconProps: { iconName: 'RemoveFilter' },
            onClick: onCancelUpload,
            disabled: selectedFile === null
        }
    ]

    const validateForm = () => {
        const validOwner = !isNullOrEmpty(objAction.owner)
        const validBeginDate = !isNullOrEmpty(objAction.beginDate)
        const validEndDate = !isNullOrEmpty(objAction.endDate)
        const validState = selectedActionStatusKey !== null;

        if (!validOwner || !validBeginDate || !validEndDate) {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-needcompleteactiondata'))
        }

        setIsInvalidActionStatus(true);

        return validOwner && validBeginDate && validEndDate && validState;
    }

    const validateFormEdit = (obj) => {
        const isInvalidOwner = isNullOrEmpty(obj.owner);
        const isInvalidExecutor = isNullOrEmpty(obj.executor);
        const isInvalidTitle = isNullOrEmpty(obj.title);
        const isInvalidAction = isNullOrEmpty(obj.action);

        const isInvalidStatus = obj.statusId <= 1 ? false : (isNullOrEmpty(obj.beginDate) || isNullOrEmpty(obj.endDate)) ;

        setObjIsValidForm({
            isInvalidAction     : isInvalidAction,
            isInvalidTitle      : isInvalidTitle,
            isInvalidOwner      : isInvalidOwner,
            isInvalidExecutor   : isInvalidExecutor,
            isInvalidStatus   : isInvalidStatus,
        })

        return !isInvalidOwner && !isInvalidExecutor && !isInvalidTitle && !isInvalidAction && !isInvalidStatus;
    }

    const onAddEditAction = (e) => {
        let formIsValid = validateFormEdit(objAction);

        if (formIsValid === true) {

            objAction.statusId = selectedActionStatusKey;

            const aux_objAction = cloneDeep(objAction);
            aux_objAction.variableName = "";

            saveActionsByElementId(inputParam_GapAnalyzeId, [aux_objAction], enum__GapActionTypes.GAP_CAUSE).then((response) => {
                if (response.data.succeeded) {
                    let incomplete = false;

                    inputParam_SelectedCauses.forEach(cause => {
                        if (cause.statusId !== 3) {
                            incomplete = true;
                        }
                    });

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    
                    inputParam_SelectedCauses.forEach(cause => {
                        cause.l_action.forEach(action => {
                            if (action.id === objAction.id) {
                                action.title = objAction.title
                                action.action = objAction.action
                                action.beginDate = objAction.beginDate
                                action.endDate = objAction.endDate
                                action.executor = objAction.executor
                                action.owner = objAction.owner
                            }
                        });
                    });

                    inputParam_SetterCauseActionList && inputParam_SetterCauseActionList(inputParam_SelectedCauses);

                    dispatch(action_setGapActions(__OBJECT_STRUCTURE_GetList(10)))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    }

    const onDeleteDocumentFromListClick = (itemId) => {
        removeDocumentById(itemId).then((response) => {
            if (response.data.succeeded) {
                setDocumentLinkList(null)
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onSaveActionCommentClick = () => {
        let formIsValid = !isNullUndefinedOrEmpty(actionComment);

        if (formIsValid === true) {
            
            objAction.statusId = selectedActionStatusKey;

            saveActionsComment(inputParam_GapAnalyzeId, 0, 0, objAction.id, 0, actionComment, 'gapaction').then((response) => {
                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    setActionComment(null);
                    setActionCommentList(null);
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        } else {
            setActionComment("");
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    }

    const onSaveActionClick = () => {
        let formIsValid = validateForm();

        if (formIsValid === true) {
            
            objAction.statusId = selectedActionStatusKey;

            const aux_objAction = cloneDeep(objAction);
            aux_objAction.variableName = "";

            saveActionsByElementId(inputParam_GapAnalyzeId, [aux_objAction], enum__GapActionTypes.GAP_CAUSE).then((response) => {
                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))

                    dispatch(action_setGapActions(__OBJECT_STRUCTURE_GetList(10)))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    }

    const onChangeActionState = (ev, item) => {
        setSelectedActionStatusKey(item.key)
    }

    const getOptionsByPermissions = () => {
        const canAllExeptCompleted = (_priv_canChangeStatusToAllExceptCompleted.value && _priv_canChangeStatusToAllExceptCompleted.mode === __enum_PageMode.Edit)
        const cantCompleted = (_priv_canChangeStatusToCompleted.value && _priv_canChangeStatusToCompleted.mode === __enum_PageMode.Edit)
        
        if (canAllExeptCompleted && cantCompleted) {
            return actionStatusList
        }
        else {
            if (canAllExeptCompleted) {
                return actionStatusList.filter(x =>
                    ((_priv_canChangeStatusToAllExceptCompleted.value && _priv_canChangeStatusToAllExceptCompleted.mode === __enum_PageMode.Edit) ?
                    x.key === selectedActionStatusKey || (x.key !== enum__ActionStatus.GAP_ACTION_CANCELED && x.key !== enum__ActionStatus.GAP_ACTION_PENDING && x.key !== enum__ActionStatus.GAP_ACTION_COMPLETED) :
                            true )
                )
            }
            else if (cantCompleted) {
                return actionStatusList.filter(x => 
                    ((_priv_canChangeStatusToCompleted.value && _priv_canChangeStatusToCompleted.mode === __enum_PageMode.Edit) ? true : false)
                )
            }
            else {
                return actionStatusList.filter(x => x.key === selectedActionStatusKey)
            }
        }
    }

    const onTextAreaChange = (e) => {
        const { value } = e.currentTarget;

        setActionComment(value);
    }

    const onShowAddForm = (value) => {
        setShowAddForm(value)
    }

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const item = documentLinkList.find(x => x.id === itemId);

        return  <div>
                    {
                        downloadInProgress &&
                        <Loading
                            inputParam_ShowLoading={true}
                            inputParam_ShowText={false}
                            inputParam_Width={'25px'}
                            inputParam_Height={'25px'}
                            inputParam_Left={""}
                            inputParam_Style={{marginTop: 0}}
                            inputParam_ColClassName={"me-2"}
                            inputParam_MarginLeft={"auto"}
                            inputParam_SpinnerSize={SpinnerSize.medium} />
                    }
                    {
                        !downloadInProgress &&
                        <OverflowSet
                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                            role="menubar"
                            items={[
                                {
                                    key: 'download',
                                    icon: 'CloudDownload',
                                    name: t('data-lang-btn-download'),
                                    title: t('data-lang-btn-download'),
                                    onClick: () => onDownloadDocumentsByIds([item.id], item.name),
                                },
                                {
                                    key: 'delete',
                                    icon: 'Delete',
                                    name: t('data-lang-btn-delete'),
                                    title: t('data-lang-btn-delete'),
                                    onClick: () => onDeleteDocumentFromListClick(item.id, item.name),
                                }
                            ].filter(x => (inputParam_EditMode && canEdit) ? true : x.key !== "delete")}
                            onRenderOverflowButton={__onRenderOverflowButton}
                            onRenderItem={__onRenderOverflowItem}
                        />
                    }
                </div>
        
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return documentLinkList[rowIndex.boundindex].id;
        }
        return documentLinkList[rowIndex]?.id;
    };

    const typeCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const item = documentLinkList.find(x => x.id === itemId);

        return  <>
                    { getKeyByValue(__DocumentTypeKeys, item.extension) }
                </>
        
    };

    return (
        <Dialog
            hidden={!inputParam_IsDialogOpen}
            onDismiss={inputParam_SetterIsDialogOpen}
            minWidth={740}
            maxWidth={1300}
            dialogContentProps={{
                type: DialogType.normal,
                styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                title: t('data-lang-lbl-action'),
            }}
            modalProps={{
                isBlocking: true,
                styles:{
                    main: {
                        selectors: {
                            '@media (min-width: 0px)': {
                                height: '85%',
                                maxHeight: '85%',
                            }
                        }
                    }
                }
            }}
        >
            {
                objAction &&
                <>
                    <Row className='pt-4 h-80'>
                        <Col className='border-end'>
                            <Row>
                                <Col>
                                    <h5>{t('data-lang-boxname-info')}</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <CLabel labelText={t('data-lang-lbl-kpi')} labelValue={objAction.variableName}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <CLabel labelText={t('data-lang-lbl-period')} labelValue={objAction.serieTimeStr}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} xl={6} className="mt-1">
                                    {
                                        (!inputParam_EditMode || (inputParam_EditMode && !canEdit)) &&
                                        <CLabel labelText={ t('data-lang-lbl-responsible') } labelValue={ objAction.owner } />
                                    }
                                    {
                                        (inputParam_EditMode && canEdit) &&
                                        <>
                                            <Picker
                                                data={ elementUserOwnerList !== null ? elementUserOwnerList : [] }
                                                mode="simpleSelect"
                                                className="dropdown-checkbox remove-position"
                                                texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                                onChange={ onChangePickerOwner }
                                                labelText={ t('data-lang-lbl-responsible') }
                                                refresh={true}
                                            />
                                            <CValidator isInValid={ objIsValidForm.isInvalidOwner } />
                                        </>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    {
                                        (!inputParam_EditMode || (inputParam_EditMode && !canEdit)) &&
                                        <CLabel labelText={ t('data-lang-lbl-executor') } labelValue={ objAction.executor } />
                                    }
                                    {
                                        (inputParam_EditMode && canEdit) &&
                                        <>
                                            <Picker
                                                data={ elementUserExecutorList !== null ? elementUserExecutorList : [] }
                                                mode="simpleSelect"
                                                className="dropdown-checkbox remove-position"
                                                texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                                onChange={ onChangePickerExecutor }
                                                labelText={ t('data-lang-lbl-executor') }
                                                refresh={true}
                                            />
                                            <CValidator isInValid={ objIsValidForm.isInvalidExecutor } />
                                        </>
                                    }
                                </Col>
                                <Col xl={12} className="mt-1">
                                    {
                                        (!canEdit) &&
                                        <CLabel labelText={ t('data-lang-lbl-title') } labelValue={ objAction.title } />
                                    }
                                    {
                                        (canEdit) &&
                                        <>
                                            <CTextBox
                                                labelText={ t('data-lang-lbl-title') }
                                                controlValue={ objAction.title }
                                                textBoxName={'title'}
                                                maxLength={50}
                                                setterControlValue={setterControlValue}
                                            />
                                            <CValidator isInValid={ objIsValidForm.isInvalidTitle } />
                                        </>
                                    }
                                </Col>
                                <Col xs={12} className="mt-1">
                                    {
                                        (!canEdit) &&
                                        <CTextAreaSimple editMode={false} labelText={ t('data-lang-lbl-action') } controlValue={ objAction.action } />
                                    }
                                    {
                                        (canEdit) &&
                                        <>
                                            <CTextAreaSimple
                                                editMode={true}
                                                maxLength={500}
                                                labelText={ t('data-lang-lbl-action') }
                                                controlValue={ objAction.action } 
                                                textBoxName={'action'}
                                                rows={20}
                                                setterControlValue={setterControlTextAreaValue}
                                            />
                                            <CValidator isInValid={ objIsValidForm.isInvalidAction } />
                                        </>
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    {
                                        (!canEdit) &&
                                        <CLabel labelText={ t('data-lang-lbl-startdate') } labelValue={ moment(objAction.beginDate).format("DD/MM/YYYY") } />
                                    }
                                    {
                                        (canEdit) &&
                                        <CDatePicker
                                            controlName={ "beginDate" } 
                                            controlValue={ objAction && objAction.beginDate } 
                                            setterControlValue={ setterControlDatePickerValue } 
                                            isInValid={ objIsValidForm.isInValidBeginDate } 
                                            labelText={ t('data-lang-lbl-startdate') } 
                                        />
                                    }
                                </Col>
                                <Col xs={12} xl={6} className="mt-1">
                                    {
                                        (!canEdit) &&
                                        <CLabel labelText={ t('data-lang-lbl-enddate') } labelValue={ moment(objAction.endDate).format("DD/MM/YYYY") } />
                                    }
                                    {
                                        (canEdit) &&
                                        <CDatePicker 
                                            controlName={ "endDate" } 
                                            controlValue={ objAction && objAction.endDate } 
                                            setterControlValue={ setterControlDatePickerValue } 
                                            isInValid={ objIsValidForm.isInValidEndDate } 
                                            labelText={ t('data-lang-lbl-enddate') } 
                                        />
                                     }
                                </Col>
                            </Row>
                            <Row className='pt-2'>
                                <Col>                                    
                                    <CLabel labelText={ t('data-lang-lbl-status') } />
                                    <Dropdown
                                        placeholder={t('data-lang-placeholder-selectoption')}
                                        options={getOptionsByPermissions()}
                                        selectedKey={selectedActionStatusKey}
                                        onChange={onChangeActionState}
                                        checkable
                                        styles={ {title: { height: "27px" }} }
                                        className="mb-1"
                                        disabled={!((!inputParam_EditMode && canEdit) || (inputParam_EditMode && !canEdit))}
                                    />
                                    <CValidator isInValid={objIsValidForm.isInvalidStatus} isInvalidText={!objIsValidForm.isInvalidStatus ? "" : null} inValidText={t('data-lang-msg-actiondatesrequiredtochangestatus')} /> 
                                </Col>
                                <Col xs={12} xl={6} className={`text-end ms-auto mt-auto ${isInvalidActionStatus? 'mb-auto pt-4' : 'mb-0'}`}>
                                    {
                                        ((!inputParam_EditMode && canEdit) || (inputParam_EditMode && !canEdit)) &&
                                        <PrimaryButton onClick={onSaveActionClick} text={t('data-lang-btn-save')} />
                                    }
                                    {
                                        (inputParam_EditMode && canEdit) &&
                                        <PrimaryButton className='ms-1' onClick={onAddEditAction} text={t('data-lang-btn-edit')} />
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row className='h-50 border-bottom'>
                                <Col>
                                    {
                                        objAction.gapActionType === "gap" &&
                                        <>
                                            <Row>
                                                <Col>
                                                    <h5>{t('data-lang-boxname-causes')}</h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                {
                                                    contextGap.dataserieFullData.value && contextGap.dataserieFullData.value.revisionDataserieFullList &&  contextGap.dataserieFullData.value.revisionDataserieFullList.flatMap(dataserie => {
                                                        const dataserieName = dataserie.name;
                                                        return dataserie.l_causes.map(cause => ({ ...cause, dataserieName }));
                                                    }).filter(cause => objAction.l_GapCauseId.find(id => id === cause.id) !== undefined).map((cause, index) => (
                                                        <Row key={index} style={{display: (index !== 0 ? "none" : "block")}}>
                                                        {
                                                            index === 0 &&
                                                                <Col>
                                                                    <CLabel labelText={t('data-lang-lbl-dataserie')} labelValue={cause.dataserieName} /><br/>
                                                                </Col>
                                                        }
                                                        </Row>
                                                    ))
                                                }
                                                </Col>
                                                <Col>
                                                    <CLabel labelText={t('data-lang-lbl-causes')} /><br/>
                                                    {
                                                        contextGap.dataserieFullData.value && contextGap.dataserieFullData.value.revisionDataserieFullList && contextGap.dataserieFullData.value.revisionDataserieFullList.flatMap(dataserie => {
                                                                const dataserieName = dataserie.name;
                                                                return dataserie.l_causes.map(cause => ({ ...cause, dataserieName }));
                                                            }).filter(cause => objAction.l_GapCauseId.find(id => id === cause.id) !== undefined).map((cause, index) => (
                                                            
                                                            <CLabel key={index} labelValue={cause.name} />
                                                        )) 
                                                    } 
                                                </Col>       
                                            </Row>
                                        </>
                                    }
                                    <Row className='pt-3'>
                                        <Col>
                                            <h5>{t('data-lang-boxname-documents')}</h5>
                                        </Col>
                                    </Row>
                                    {
                                        (canEdit) &&
                                        <Row>
                                            <Col>
                                                <div className='d-flex'>
                                                    <div className='d-flex align-items-center'>
                                                        <TooltipHost content={
                                                            <>
                                                                <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                                                <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                                            </>
                                                        }>
                                                            <Form.Control ref={fileUploadControl} type="file" size="sm" onChange={ handleFileInput } />
                                                        </TooltipHost>
                                                        {
                                                            !uploadInProgress &&
                                                            <CommandBar items={commandItems} />
                                                        }
                                                        {
                                                            uploadInProgress &&
                                                                <Loading
                                                                    inputParam_ShowLoading={true}
                                                                    inputParam_ShowText={false}
                                                                    inputParam_Width={'25px'}
                                                                    inputParam_Height={'25px'}
                                                                    inputParam_Left={""}
                                                                    inputParam_Style={{marginTop: 0}}
                                                                    inputParam_ColClassName={"me-2"}
                                                                    inputParam_MarginLeft={"auto"}
                                                                    inputParam_SpinnerSize={SpinnerSize.medium} />
                                                        }
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    <Row className='h-80'>
                                        <Col>
                                            {
                                                documentLinkList &&
                                                <JqxGrid
                                                    altrows={true}
                                                    enabletooltips={true}
                                                    width={'100%'}
                                                    theme={'light'} 
                                                    height={'160px'}
                                                    editable={false}
                                                    sortable={false}
                                                    filterable={false}
                                                    showfilterrow={false} 
                                                    localization={getGridLocalization(t)}
                                                    source={ new jqx.dataAdapter({
                                                        localData: documentLinkList,
                                                        dataType: 'array',
                                                        dataFields: [
                                                            { name: 'id',                    type: 'number' },
                                                            { name: 'extension',             type: 'string' },
                                                            { name: 'documentCode',          type: 'string' },
                                                            { name: 'name',                  type: 'string' },
                                                            { name: 'modificationUsername',  type: 'string' },
                                                            { name: 'creationUsername',      type: 'string' },
                                                        ],
                                                        id: 'id'
                                                    })}
                                                    columns={[
                                                        { index: null, text: 'ID',                                    dataField: 'id',                   width: '0px',   columntype: 'textbox', editable: false, hidden: true },
                                                        { index: null, text: t('data-lang-lbl-actions'),              dataField: 'acciones',             width: '50px', pinned: true,
                                                            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                                                            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                                                        },
                                                        { index: null, text: t('data-lang-lbl-type'),                 dataField: 'extension',            width: '50px', pinned: true, cellclassname: 'text-center',
                                                            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(typeCellsRenderer(row), htmlElement); },
                                                            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(typeCellsRenderer(row), htmlElement); },
                                                        },
                                                        { index: 0,    text: t('data-lang-lbl-code'),                 dataField: 'documentCode',         width: '80px',  columntype: 'textbox', editable: false, pinned: false },
                                                        { index: 1,    text: t('data-lang-lbl-name'),                 dataField: 'name',                 width: '180px', columntype: 'textbox', editable: false, pinned: false },
                                                        { index: 2,    text: t('data-lang-lbl-modificationusername'), dataField: 'modificationUsername', width: '120px', columntype: 'textbox', editable: false, pinned: false },
                                                        { index: 3,    text: t('data-lang-lbl-creationusername'),     dataField: 'creationUsername',     width: '110px', columntype: 'textbox', editable: false, pinned: false },
                                                    ]}
                                                />
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {
                                <Row className='h-50'>
                                    <Col>
                                        <Pivot styles={{root: {whiteSpace: "normal !important"}}} onLinkClick={onSelectPivotKey} selectedKey={selectedPivotKey} defaultSelectedKey="0">
                                            <PivotItem headerText={ t('data-lang-lbl-comments') }>
                                                <Row>
                                                    {
                                                        canEdit && showAddForm &&
                                                        <Col>
                                                            <Row>
                                                                <Col>
                                                                    <CTextAreaSimple
                                                                        labelText={t('data-lang-lbl-comment')}
                                                                        controlValue={actionComment}
                                                                        setterControlValue={onTextAreaChange}
                                                                        isInvalirControl={actionComment === ""}
                                                                        editMode={canEdit}
                                                                        rows={10}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col></Col>
                                                                <Col className='col-auto ms-auto mt-2'>
                                                                    <DefaultButton text={t('data-lang-btn-cancel')} className='me-2' onClick={() => onShowAddForm(false)} />
                                                                    <PrimaryButton text={t('data-lang-btn-add')} onClick={onSaveActionCommentClick} />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    }
                                                    <Col className='bordet-start'>
                                                        <Row>
                                                            <Col className='d-flex'><b>{t('data-lang-lbl-comments')}</b>&nbsp;&nbsp; { !showAddForm && <IconButton iconProps={{iconName: "Add"}} onClick={() => onShowAddForm(true)} /> }</Col>
                                                        </Row>
                                                        <Row className='h-85 border commentHeigth' style={{overflowY: "scroll"}}>
                                                            {
                                                                actionCommentList && 
                                                                <Col className={actionCommentList.length === 0 ? 'm-auto col-auto' : ''}>
                                                                {
                                                                    actionCommentList.length > 0 && actionCommentList.map(comment => 
                                                                        <Row className='border'>
                                                                            <Col>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <TooltipHost
                                                                                            content={ comment.gapDataserieName }
                                                                                            overflowMode={TooltipOverflowMode.Self}
                                                                                            hostClassName={css({
                                                                                                overflow: {
                                                                                                overflow: 'hidden',
                                                                                                textOverflow: 'ellipsis',
                                                                                                },
                                                                                            })}
                                                                                            onTooltipToggle={false}
                                                                                            styles={{
                                                                                                root: { display: 'flex', width: "100%" },
                                                                                            }}
                                                                                        >
                                                                                            <CLabel labelText={t('data-lang-lbl-kpi')} labelValue={comment.gapDataserieName} />
                                                                                        </TooltipHost>
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <CLabel labelText={t('data-lang-lbl-comment')} labelValue={comment.gapEventComment} />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <Row>
                                                                                            <Col>
                                                                                                <CLabel labelText={t('data-lang-lbl-date')} labelValue={moment(comment.gapEventDate).format("DD/MM/YYYY")} />
                                                                                            </Col>
                                                                                            {
                                                                                                objAction.gapActionType === "gap" &&
                                                                                                <Col>
                                                                                                    <CLabel labelText={t('data-lang-lbl-period')} labelValue={comment.gapDataseriePeriodId} />
                                                                                                </Col>
                                                                                            }
                                                                                            <Col>
                                                                                                <CLabel title={comment.GapEventUsername} labelText={t('data-lang-lbl-user')} labelValue={comment.gapEventFullname} />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        </Row>
                                                                    )
                                                                }
                                                                {
                                                                    actionCommentList.length === 0 &&
                                                                    <NoDataLayer display={ (actionCommentList.length === 0) } />
                                                                }
                                                                </Col>
                                                            }
                                                            {
                                                                !actionCommentList &&
                                                                <NoDataLayer display={ !actionCommentList } />
                                                            }
                                                        </Row>
                                                        <Row className='mt-auto mx-auto h-15 col-auto d-flex'>
                                                            <Col></Col>
                                                            <Col className='col-auto me-auto'>
                                                                <ActionButton text={`< ${t('data-lang-lbl-prev')}`} onClick={onGetPrevCommentsClick} />
                                                            </Col>
                                                            <Col className='col-auto my-auto'>|</Col>
                                                            <Col className='col-auto ms-auto'>
                                                                <ActionButton text={`${t('data-lang-lbl-next')} >`} onClick={onGetNextCommentsClick} />
                                                            </Col>
                                                            <Col></Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </PivotItem>
                                            <PivotItem headerText={ t('data-lang-lbl-events') }>
                                                <Row>
                                                    <Col className='eventHeigth' style={{overflowY: "scroll"}}>
                                                        {
                                                            actionLogList && actionLogList.map(log => 
                                                                <Row className='border'>
                                                                    <Col>
                                                                        <Row>
                                                                            <Col>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <TooltipHost
                                                                                            content={ t(log.gapEventName) }
                                                                                            overflowMode={TooltipOverflowMode.Self}
                                                                                            hostClassName={css({
                                                                                                overflow: {
                                                                                                overflow: 'hidden',
                                                                                                textOverflow: 'ellipsis',
                                                                                                },
                                                                                            })}
                                                                                            onTooltipToggle={false}
                                                                                            styles={{
                                                                                                root: { display: 'flex', width: "100%" },
                                                                                            }}
                                                                                        >
                                                                                            <CLabel labelText={t('data-lang-lbl-event')} labelValue={t(log.gapEventName)} />
                                                                                        </TooltipHost>
                                                                                    </Col>
                                                                                    <Col>
                                                                                        <CLabel labelText={t('data-lang-lbl-date')} labelValue={!isNullUndefinedOrEmpty(log.gapEventDate) ? moment(log.gapEventDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata')} />
                                                                                    </Col>
                                                                                </Row>  
                                                                            </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col title={!isNullUndefinedOrEmpty(log.gapEventUsername) ? log.gapEventUsername : '--'}>
                                                                                <CLabel labelText={t('data-lang-lbl-user')} labelValue={!isNullUndefinedOrEmpty(log.gapEventFullname) ? log.gapEventFullname : '--'} />
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                            </PivotItem>
                                        </Pivot>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                    
                </>
            }
            <DialogFooter>
                <Row className='row w-100'>
                    <Col className="mt-2">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        /> 
                    </Col>
                    <Col className="mt-2 col col-auto ms-auto">
                        <DefaultButton onClick={onCloseDialog} text={t('data-lang-btn-close')} />
                    </Col>
                </Row>
            </DialogFooter>
        </Dialog>
    )
};

DialogAction.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_IsDialogOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsDialogOpen: PropTypes.func.isRequired,
    inputParam_DialogEntity: PropTypes.object,
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_GapElementId: PropTypes.number,
    inputParam_SetterCauseActionList: PropTypes.func,
    inputParam_SelectedCauses: PropTypes.array,
};

export default DialogAction;